// AI-CONTEXT: See docs/features/updates-log.md

/** Boven dit aantal staat er '9+': een groot getal leest als achterstand. */
const MAX_ZICHTBAAR = 9

/**
 * De teller bij het menu-item 'Updates': hoeveel updates deze gebruiker nog
 * niet gezien heeft. Rendert niets zolang het aantal niet bekend is (null) of
 * nul is — een badge die even later verschijnt is geen bewering, een badge
 * met '0' wel.
 *
 * @param {object} props
 * @param {number|null} props.count - Aantal ongelezen updates; null = nog niet bekend
 */
const UpdatesBadge = ({ count }) => {
    if (typeof count !== 'number' || count <= 0) return null

    const label = count > MAX_ZICHTBAAR ? `${MAX_ZICHTBAAR}+` : String(count)
    const omschrijving = count === 1 ? '1 nieuwe update' : `${count} nieuwe updates`

    return (
        <span className='updates-badge' aria-label={omschrijving} title={omschrijving}>
            {label}
        </span>
    )
}

export default UpdatesBadge
